import { Action, Dispatch, Reducer } from 'redux';
import { RequestState } from '../models/RequestState';
import StatusCode from '../util/StatusCode';
import InstanceClient from '../services/InstanceClient';

enum ActivityInformationMarkingsType {
    LIST_INFORMATION_MARKINGS = 'LIST_INFORMATION_MARKINGS',
}

export interface InformationMarkingsState {
    informationMarkings: RequestState<string[]>
}

interface Activity_ListInformationMarkings extends Action<ActivityInformationMarkingsType> {
    type: ActivityInformationMarkingsType.LIST_INFORMATION_MARKINGS
    informationMarkings: RequestState<string[]>
}


export const ListInformationMarkings = () => (dispatch: Dispatch<Activity_ListInformationMarkings>) => {
    dispatch({
        type: ActivityInformationMarkingsType.LIST_INFORMATION_MARKINGS,
        informationMarkings: { code: StatusCode.PENDING },
    });

    InstanceClient.get<string[]>(`/api/core/activityinformationmarkings`)
        .then(resp => dispatch({
            type: ActivityInformationMarkingsType.LIST_INFORMATION_MARKINGS,
            informationMarkings: { code: StatusCode.COMPLETE, data: resp.data }
        }))
        .catch(error => dispatch({
            type: ActivityInformationMarkingsType.LIST_INFORMATION_MARKINGS,
            informationMarkings: { code: StatusCode.ERROR, error }
        }));
};

const initialState: InformationMarkingsState = {    
    informationMarkings: { code: StatusCode.PENDING }
}

export const reducer: Reducer<InformationMarkingsState, Activity_ListInformationMarkings> = (state, action) => {
    state = state || initialState;

    switch (action.type) {        
        case ActivityInformationMarkingsType.LIST_INFORMATION_MARKINGS:
            return {
                ...state,
                informationMarkings: action.informationMarkings,
            }
        default:
            return state;
    }
};